import React from 'react';
import { Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ChatCard from './components/ChatCard';

const Chat = ({ t }) => (
  <div className="containerInside__wrap" >
    <Container>
      <Row>
        <ChatCard />
      </Row>
    </Container>
  </div>
);

Chat.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(Chat);
